/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import MDBox from "~/components/MDBox";
import PublicFooter from "~/pages/public/PublicFooter";

const Eula = () => {
  return (
    <MDBox m={4}>
      <Box mb={6}>
        <div className="content-wrapper">
          <div className="content mt-5 pt-5 pb-5 container">
            <h2 className="text-center">End User License Agreement</h2>
            <p>
              <strong>IMPORTANT!</strong>
            </p>
            <p>
              <strong>
                READ CAREFULLY AND UNDERSTAND ALL OF THE RIGHTS AND RESTRICTIONS
                DESCRIBED IN THIS AGREEMENT BEFORE INSTALLING THE SOFTWARE. BY
                CLICKING THE BUTTON INDICATING YOUR ACCEPTANCE AS STATED BELOW
                OR INSTALLING THE SOFTWARE, YOU AGREE TO BE BOUND BY THE TERMS
                AND CONDITIONS OF THIS AGREEMENT. IF YOU DO NOT AGREE TO THE
                FOLLOWING TERMS AND CONDITIONS OF THIS AGREEMENT, DO NOT USE THE
                SOFTWARE.{" "}
              </strong>
            </p>
            <p>
              This End User License Agreement (hereinafter referred to as
              “EULA”) is a legal agreement between
              <strong>Team Computers Private Limited (“TCPL”)</strong>, a
              company incorporated under the Indian Companies Act and having its
              registered office at, No.1, Mohammadpur, Near Bhikaji Cama Place,
              Delhi-110066, hereinafter referred to as “Licensor”
              <strong>And</strong> an individual or a legal entity, hereinafter
              referred to as ”Licensee”, who pays the requisite consideration to
              the Licensor or any person authorized by the Licensor including
              resellers or is using the software as a trial version. Any person
              (natural or legal), who copies, installs, downloads or uses this
              software in any manner or accepts this eula shall be bound by the
              terms and conditions of this EULA.{" "}
              <strong>
                Any person (natural or legal) who does not accept the terms and
                conditions of this EULA shall refrain from copying, installing,
                downloading or using the software in any manner
              </strong>
              .
            </p>

            <p>
              <strong>1. Definitions</strong>
            </p>

            <p>
              <strong>1.1.</strong> <em>“Party” </em>shall mean either Licensor
              or Licensee based on the context and “Parties” shall mean both
              Licensor and Licensee.
            </p>
            <p>
              <strong>1.2.</strong> <em>“Licensed Software” </em>shall mean the
              software specified by the Licensee in the Purchase form.
            </p>
            <p>
              <strong>1.3.</strong> <em>“Intellectual Property” </em>shall mean
              any idea, creation, invention, work of authorship, information or
              any other material relating to the Licensed Software or User
              Documentation, which is protected, in the process of being
              protected or capable of being protected as a patent, copyright,
              trade mark, trade secret or any other type of intellectual
              property.
            </p>
            <p>
              <strong>1.4.</strong>
              <em> "Upgrades" </em>shall mean any and all changes or additions
              to the Licensed Software, including new releases and versions
              thereof that add new functions to, or improve performance of, the
              Licensed Software.
            </p>
            <p>
              <strong>1.5.</strong>
              <em> "Confidential Information" </em>shall mean any information,
              including but not limited to ideas, source code, object or binary
              code, algorithms, operations, designs, methods, processes,
              practices, marketing plans, strategies, documents, data, programs,
              patterns, compilations, customer information, financial
              information, business information, know-how and such other
              information, which is disclosed by Licensor to the Licensee
              verbally or in writing or which comes to the knowledge of Licensee
              in any manner and which is deemed confidential by the Licensor.
            </p>
            <p>
              Exclusions: Confidential information shall not include: i) The
              information which is in the public domain; or ii) The information
              which is lawfully obtained or available from a third party without
              any obligation of confidentiality and without breach of this EULA;
              or iii) The information, which was already known to The Licensee
              and has been received from a source other than the Licensor.
            </p>

            <p>
              <strong>1.6.</strong> “User Documentation” shall mean the
              explanatory printed or electronic materials that relate to the
              Licensed Software, including, but not limited to, license
              specifications, activation code, license files, instructions on
              how to use the Software, and/or technical specifications.
            </p>
            <p>
              <strong>1.7.</strong> “Purchase Form” shall mean the form filled
              by a Licensee either electronically or in hard copy for acquiring
              a license with respect to licensed software from the licensor.
            </p>
            <p>
              1.8. “Reseller” shall mean any person authorized by the Licensor
              in writing to vend, sell or distribute the licensed software
              within the territory permitted by the Licensor.
            </p>

            <p>
              <strong>2 Grant of License</strong>
            </p>

            <p>
              <strong>2.1. License </strong>
            </p>
            <p>
              The Licensor hereby grants a non-exclusive and non-transferable
              license to Licensee to use the Licensed Software and User
              Documentation from the date of accepting this EULA (“Effective
              Date”) for the term specified in the form for purchase of the
              license filled by the Licensee (“Purchase form”) and after paying
              the necessary consideration for licensing the software. The
              Licensee shall not sub-license the Licensed Software to any person
              without written permission of the Licensor.
            </p>
            <p>
              <strong>2.2. License of Trial Version</strong>
            </p>
            <p>
              In case of trial version of the Licensed Software, the Licensor
              hereby grants to the Licensee a non-exclusive and non-transferable
              right to use the Licensed Software with the features permitted by
              the Licensor for a limited period permitted by the licensor. On
              expiry of the trial period permitted by the licensor, the Licensee
              shall not use the Licensed Software and shall delete, erase or
              destroy copies of the Licensed Software in its possession.
            </p>
            <p>
              <strong>2.3. Use by Affiliates</strong>
            </p>
            <p>
              The Licensee shall have the right to use the Licensed Software
              only in the manner permitted by the Licensor as provided in this
              EULA. The Licensed Software may be used by the Licensee’s
              Affiliates with written permission of the Licensor subject to the
              terms and conditions of this EULA provided that (a) such use is
              only for the Licensee’s benefit, (b) Licensee agrees to remain
              responsible for each such Affiliate’s compliance with the terms
              and conditions of this EULA and (c) Licensee provides the Licensor
              with advance written notice of each such Affiliate. Use of the
              Licensed Software by the Affiliates and Licensee in the aggregate
              must be within the restrictions contained in the applicable
              Purchase Form. (The term “Affiliate” used here shall mean any
              entity under the control of the Licensee, where “control” shall
              mean ownership of or the right to control greater than 50% of the
              voting securities of an entity.).
            </p>
            <p>
              <strong>2.4 Support</strong>
            </p>
            <p>
              The Licensor will provide support from time to time to the
              Licensee with respect to use of the Licensed Software for the
              period of subscription from the Effective Date of this EULA.
            </p>

            <p>
              <strong>3. Obligations and Limitations</strong>
            </p>
            <p>
              <strong>3.1. Restricted Actions</strong>
            </p>
            <p>
              The Licensee shall not be permitted to take any of the following
              actions: a. use the Licensed Software in a manner not permitted
              under this EULA; b. reverse engineer, decompile, or disassemble
              the Licensed Software; c. distribute, provide access, rent, loan,
              lease, sell, sublicense, or otherwise transfer all or any portion
              of the Licensed Software or User Documentation, or any rights
              granted in this EULA, to any other person without the prior
              written consent of the Licensor; d. Remove or modify any of the
              notices on the Licensed Software or User Documentation; e.
              Circumvent any security measures used to protect the Licensed
              Software; f. Make any modifications to the Licensed Software or
              combine the Licensed Software with a third party software without
              prior written permission of the Licensor; and g. publish, promote,
              broadcast, circulate or refer publicly to the Licensor's name,
              trade name, trademark, service mark or logo; and h. Take multiple
              Trial version licenses with respect to the Licensed Software from
              the Licensor during the term of this EULA or thereafter unless a
              prior written permission or consent has been taken from the
              Licensor.
            </p>
            <p>
              <strong>3.2. Information about Breach</strong>
            </p>
            <p>
              The Licensee shall inform the Licensor in writing on becoming
              aware of breach of this EULA by the Licensee or its employees. On
              receiving information that the Licensee may be breaching this
              EULA, the Licensor may require the Licensee to submit a
              certificate of non-breach from an independent auditor. On
              non-submission of the certificate, the Licensor shall have the
              right to terminate the EULA immediately.
            </p>

            <strong>4 Consideration</strong>

            <p>
              <strong>4.1.</strong> The Licensor is not charging any
              consideration or license fee for Licensed Software. However, the
              Licensor shall duly notify its Users in the event the Licensed
              Software or a part thereof (including any updates or upgrades)
              should become chargeable.
            </p>

            <strong>5. Intellectual Property</strong>

            <p>
              <strong>5.1. Ownership</strong>
            </p>
            <p>
              All rights, title and interest in the Intellectual Property
              relating to the Licensed Software vests with the Licensor and
              shall continue to vest with the Licensor. This EULA shall not
              amount to transfer of any Intellectual Property or authorization
              with respect to any Intellectual Property in the Licensed Software
              by the Licensor to the Licensee except as expressly provided in
              clauses 2 and 3 of this EULA.
            </p>
            <p>
              <strong>5.2. Enhancements</strong>
            </p>
            <p>
              The Licensor shall have a non-exclusive license over any
              intellectual property with respect to any enhancements to the
              Licensed Software made by the Licensee with permission of the
              licensor in writing.
            </p>
            <p>
              <strong>5.3. Third Party Software</strong>
            </p>
            <p>
              If the Licensor mentions on its website, user documentation or any
              other place, existence of any third party software, whose
              intellectual property permission has not been acquired by the
              Licensor and must be used in combination with the Licensed
              Software, the Licensee shall be responsible to acquire the
              permission or license in order to use the said software. The
              Licensor shall not be responsible for acquiring licenses with
              respect to the said software.
            </p>

            <strong>6 Confidentiality and Privacy</strong>

            <p>
              <strong>6.1. Confidentiality</strong>
            </p>
            <p>
              Licensee agrees to maintain confidentiality of all Confidential
              Information of the Licensor.
            </p>
            <p>
              <strong>6.2. Permitted Use</strong>
            </p>
            <p>
              The Licensee shall be permitted to use the Confidential
              Information only for exercising rights granted by the Licensor
              under this EULA. The Licensee shall not use the Confidential
              Information for any other purpose without the Licensor’s written
              permission.
            </p>
            <p>
              <strong>6.3. Security Measures</strong>
            </p>
            <p>
              Licensee shall implement stringent physical security and
              information security measures for maintaining secrecy of the
              Licensor’s Confidential Information. Such measures shall be at
              least as stringent as the measures taken by the Licensee to
              safeguard its own Confidential Information of the like nature.
            </p>
            <p>
              <strong>6.4 Personal Data</strong>
            </p>
            <p>
              Licensee hereby permits the Licensor to store and use the personal
              data, if any, of the Licensee for providing and tracking the
              Licensee's access to the Licensed Software and to improve
              facilities offered through the Licensed Software. The Licensee
              also permits the Licensor to provide information regarding new
              facilities or databases and other services offered by Licensor.
              Licensee hereby agrees that the Licensee has read and shall be
              bound by the privacy policy of the Licensor.
            </p>
            <p>
              <strong>6.5. Survival</strong>
            </p>
            <p>
              The provisions relating to confidentiality shall survive the
              termination of this EULA.
            </p>
            <p>
              <strong>6.6 Privacy Policy</strong>
            </p>
            <p>
              Because the privacy of your personal information is very important
              to us, the Licensor has established a{" "}
              <Link to="privacy-policy">
                <em>Privacy Policy</em>
              </Link>{" "}
              which describes how we will treat any personal information which
              you may provide to us. By accepting this EULA, you acknowledge
              that you have read and understood the Licensor’s Privacy Policy.
            </p>

            <strong>7. Term and Termination</strong>

            <p>
              <strong>7.1. Term</strong>
            </p>
            <p>
              The term of this EULA shall be the term provided in the Purchase
              form from the Effective Date unless terminated earlier as provided
              hereunder.
            </p>
            <p>
              <strong>7.2. Default</strong>
            </p>
            <p>
              The Licensor may terminate this EULA on default of the Licensee to
              abide by the terms and conditions of this EULA. The Licensor may
              also terminate the EULA if there is any suit filed against the
              Licensor with respect to the Licensed Software by giving the
              Licensee a notice of seven (7) days.
            </p>
            <p>
              <strong>7.3. Consideration on termination</strong>
            </p>
            <p>
              On termination of the EULA, the Licensee shall be liable to pay
              the consideration due to the Licensor (if any) on the termination
              date. The Licensor shall not be liable to refund any consideration
              to the Licensee on termination of the EULA for any reason before
              the expiry of the term of the EULA.
            </p>
            <p>
              <strong>7.4. Post-termination Obligations</strong>
            </p>
            <p>
              On termination of the EULA, the Licensee shall do the following:
              (a) Ensure that the use of the Licensed Software is ceased; (b)
              Delete and destroy all copies of the Licensed Software in its
              possession; and (c) provide a certificate to the Licensor that all
              copies of the Licensed Software have been destroyed to the
              satisfaction of the Licensor.
            </p>
            <p>
              <strong>7.5. Survival</strong>
            </p>
            <p>
              The provisions relating to Intellectual Property, Confidentiality,
              Liability and Indemnity shall survive the termination of this
              EULA.
            </p>

            <strong>8. Warranty and Liability</strong>

            <p>
              <strong>8.1. Limitation of Warranty</strong>
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND,
              EITHER EXPRESSED OR IMPLIED AND THE LICENSOR SPECIFICALLY
              DISCLAIMS ANY OTHER WARRANTY INCLUDING, WITHOUT LIMITATION, THE
              IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
              PURPOSE AND NON-INFRINGEMENT. ANY STATEMENTS OR REPRESENTATIONS
              ABOUT THE SOFTWARE AND ITS FUNCTIONALITY IN THE USER
              DOCUMENTATION, OR ANY COMMUNICATION WITH THE LICENSOR CONSTITUTE
              TECHNICAL INFORMATION AND NOT AN EXPRESS WARRANTY OR GUARANTEE.
              WITHOUT LIMITING THE FOREGOING, THE LICENSOR DOES NOT WARRANT THAT
              THE OPERATION OF THE SOFTWARE WILL BE UNINTERRUPTED OR ERROR FREE.
              THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE SOFTWARE
              IS WITH YOU. SHOULD THE SOFTWARE PROVE DEFECTIVE, YOU ASSUME THE
              ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION.
            </p>
            <p>
              <strong>8.3. Limitation of Liability</strong>
            </p>
            <p>
              The Licensee shall have the right to use the Licensed Software in
              a lawful manner within the scope of license granted under this
              EULA. The Licensor shall not be liable for any consequences of the
              use of the Licensed Software by the Licensee.
            </p>
            <p>
              <strong>8.4. No Liability</strong>
            </p>
            <p>
              IN NO EVENT SHALL THE LICENSOR, ITS AFFILIATES OR ITS LICENSORS
              HAVE ANY LIABILITY FOR ANY INCIDENTAL, SPECIAL, INDIRECT, OR
              CONSEQUENTIAL DAMAGES, LOSS OF PROFITS, REVENUE, DATA, OR COST OF
              COVER. IN ADDITION, IN NO EVENT SHALL THE LIABILITY OF THE
              LICENSOR, ITS AFFILIATES OR ITS LICENSORS FOR ANY DAMAGES ARISING
              OUT OF OR IN CONNECTION WITH THE LICENSED SOFTWARE, USER
              DOCUMENTATION OR THIS EULA EXCEED THE AMOUNT PAID OR PAYABLE BY
              THE LICENSEE FOR THE LICENSED SOFTWARE. THE LIMITATIONS OF
              LIABILITY IN THIS SECTION SHALL APPLY TO ANY DAMAGES, HOWEVER
              CAUSED AND REGARDLESS OF THE THEORY OF LIABILITY, WHETHER DERIVED
              FROM CONTRACT, TORT (INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE),
              OR OTHERWISE, EVEN IF THE LICENSOR HAS BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES AND REGARDLESS OF WHETHER THE LIMITED
              REMEDIES AVAILABLE HEREUNDER FAIL OF THEIR ESSENTIAL PURPOSE.
            </p>
            <p>
              <strong>8.5. Third Party IP Infringement</strong>
            </p>
            <p>
              If the Licensed Software becomes, or in the opinion of the
              Licensor may become, the subject of a claim of infringement of any
              third party’s intellectual property rights, the Licensor may, at
              its option and in its discretion: (i) procure for Licensee the
              right to use the Software free of any liability; or (ii) replace
              or modify the Software to make it non-infringing. The foregoing
              states the sole liability of the Licensor and the exclusive remedy
              of Licensee for any infringement of intellectual property rights
              by the Licensed Software or any other items provided by the
              Licensor under this EULA.
            </p>

            <strong>9. Indemnification</strong>

            <p>
              The Licensee shall be liable to indemnify, defend and hold the
              Licensor harmless from and against claims, losses, expenses,
              damages, liabilities, expenses and costs, including reasonable
              attorneys’ fees, resulting from (a) any violation of this EULA,
              (b) any violation of the rights of a third party, and (c) any use
              of the Application or any results obtained from it. The Licensor
              reserves the right, at its own expense, to assume the exclusive
              defence and control of any matter subject to indemnification
              hereunder. In any event, no settlement which affects the rights or
              obligations of the Licensor may be made without Licensor’s prior
              written approval.
            </p>

            <strong>10. Publicity Rights</strong>

            <p>
              Licensee grants the Licensor the right to include Licensee as a
              customer in Software promotional material. Licensee can deny the
              Licensor this right at any time by submitting a written request
              via email to the Licensor requesting to be excluded from Software
              promotional material. Requests made after purchasing may take
              thirty (30) calendar days to process.
            </p>

            <strong>11. Governing Law and Dispute Resolution</strong>

            <p>
              <strong>11.1. Governing Law</strong>
            </p>
            <p>
              This EULA shall be governed by the laPlantWatch Pro of Republic of
              India without regard to conflict of law principles. The Parties
              agree to submit to the exclusive jurisdiction of the courts in
              Delhi.
            </p>
            <p>
              <strong>11.2 Arbitration</strong>
            </p>
            <p>
              The Parties shall endeavour to resolve all disputes arising under
              this EULA through negotiation in good faith. In case the Parties
              are not able to resolve the disputes through negotiation, the
              Parties shall resolve the dispute through arbitration in
              accordance with the Arbitration and Conciliation Act, 1996 (and
              the amendments thereof). The Parties agree to mutually appoint a
              sole arbitrator or in the event the Parties cannot arrive at a
              consensus, each Party shall appoint an arbitrator who shall choose
              a third arbitrator to preside over the proceedings. The language
              if the Arbitration shall be English and the seat of Arbitration
              shall be in Delhi.
            </p>

            <strong>12. Export Control Law</strong>

            <p>
              The Licensee shall be responsible for complying with all export
              control laPlantWatch Pro of the country where the Licensed
              Software is acquired or used. The Licensee shall not use the
              Licensed Software in any manner if it cannot comply with the
              export control laPlantWatch Pro. It shall be the sole
              responsibility of the Licensee to acquire any regulatory approvals
              necessary to use the Licensed Software.
            </p>

            <strong>13. Assignment</strong>

            <p>
              This EULA and all its rights and privileges hereunder shall not be
              assigned by the Licensee without the prior written consent of the
              Licensor.
            </p>

            <p>
              <strong>14. Severability</strong>
            </p>

            <ul>
              <li>
                Should any part of this EULA be declared illegal or
                unenforceable, the Parties agree to co-operate in all the ways
                open to them to obtain substantially the same result or as much
                thereof as may be possible, including taking appropriate steps
                to amend, modify or alter this EULA.
              </li>
            </ul>
            <ul>
              <li>
                If any term or provision of this EULA shall be hereafter
                declared by a final adjudication of any tribunal or court of
                competent jurisdiction to be illegal or invalid, such
                adjudication shall not alter the validity or enforceability of
                any other term or provision unless the terms and provisions
                declared (by any of the Parties) shall be one expressly defined
                as a condition precedent or as of the essence of this EULA, or
                comprising an integral part of, or inseparable from the
                remainder of this EULA.
              </li>
            </ul>

            <p>
              <strong>15. Waiver and Amendment</strong>
            </p>

            <p>
              <strong>15.1. Waiver</strong>
            </p>
            <p>
              The failure, with or without intent, of any Party hereto to insist
              upon the performance of the terms of this EULA by the other Party,
              shall not be treated as, or be deemed to constitute, a
              modification of any terms or stipulations of this EULA nor shall
              such failure or election be deemed to constitute a waiver of the
              right of such Party, at any time whatsoever thereafter, to insist
              upon performance by the other, strictly in accordance with any
              terms or provisions hereof.
            </p>
            <p>
              <strong>15.2. Amendment</strong>
            </p>
            <p>
              The Licensor reserves the right to amend this EULA at any time by
              updating this posting or by providing notice other appropriate
              notice. Therefore, it is important that you review this EULA
              regularly so that you are aware of any changes. Your continued use
              of the Licensed Software following any change shall be deemed to
              be an acceptance of any such change. If you do not agree to any
              modification of this EULA, you must immediately stop accessing or
              using the Licensed Software.
            </p>
            <p>
              <strong>15.3 Modifications to the Licensed Software</strong>
            </p>
            <p>
              The Licensor reserves the right at any time to modify or suspend
              access to the Licensed Software (whether on a temporary or
              permanent basis) with or without notice. The Licensor shall not
              have any liability associated with exercising this right.
            </p>

            <p>
              <strong>16. Notice</strong>
            </p>

            <ul>
              <li>
                All notices hereunder shall be in writing and shall be duly
                given if delivered personally or sent by registered mail, return
                receipt requested to the respective addresses of the Parties
                provided in this EULA or in the User Documentation or Purchase
                form or if sent by e-mail or fax to the address or number
                specified the receiving Party.
              </li>
            </ul>
            <ul>
              <li>
                The Licensee shall notify any change of address for
                communication of notices to the Licensor within fourteen (14)
                days of such a change.
              </li>
            </ul>

            <p>
              <strong>17. Entire EULA</strong>
            </p>

            <p>
              This EULA constitutes the entire EULA between the Parties
              pertaining to the Licensed Software and supersedes all prior
              EULAs, understandings, negotiations and discussions with respect
              to the subject matter hereof whether oral or written.
            </p>

            <p>
              <strong>18. Force Majeure</strong>
            </p>

            <p>
              The performance of any part of this EULA by the Licensor shall be
              excused to the extent that such performance is hindered, delayed,
              or made impractical by flood, fire, war, or riot, natural
              disaster, pathogenic outbreak of a contagious disease or any other
              cause beyond the reasonable control of the Licensor. Upon the
              occurrence of any such event the Licensor shall notify the
              Licensee of such an occurrence.
            </p>

            <p>
              <strong>19. General Disclaimer</strong>
            </p>

            <p>
              This EULA shall come into force as soon as the Licensee accepts
              the EULA or copies, installs or downloads the Licensed Software or
              starts using the software after paying the consideration to the
              Licensor unless it is a trial version. By clicking on I Accept or
              copying or downloading or installing or using the Licensed
              Software, the Licensee agrees to be bound by the terms and
              conditions of this EULA.
            </p>
          </div>
        </div>
      </Box>
      <PublicFooter />
    </MDBox>
  );
};

export default Eula;
